/**
 * Element - image
 */

export const image = ():void => {

  // Run the script for each individual element found on the page
  const elementSelector = document.querySelectorAll('.js-image') as unknown as HTMLElement[]
  elementSelector.forEach((component:HTMLElement) => {

  })

}
